import * as React from "react";
import { SVGProps } from "react";

const Patientory = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    viewBox="0 0 344 329"
    {...props}
  >
    <style>{".st0{fill:#42b34f}"}</style>
    <path d="M106.8 71.1v23c0 14.6-11.8 26.3-26.3 26.3H29.6C13.3 120.3 0 133.7 0 150v43.4C0 209.7 13.3 223 29.6 223h50.9c14.6 0 26.3 11.9 26.3 26.3v50.9c0 16.3 13.3 29.6 29.6 29.6h43.4c16.3 0 29.6-13.3 29.6-29.6v-50.9c0-14.6 11.8-26.3 26.3-26.3h23c-83.6 0-151.9-68.3-151.9-151.9z" />
    <path
      d="M316.2 193.4V150c0-16.3-13.3-29.6-29.6-29.6h-50.9c-14.6 0-26.3-11.8-26.3-26.3V43.2c0-16.3-13.3-29.6-29.6-29.6h-43.4c-16.3 0-29.6 13.3-29.6 29.6v27.9c0 83.6 68.4 151.9 151.9 151.9h27.9c16.3 0 29.6-13.3 29.6-29.6z"
      className="st0"
    />
    <path
      d="M240.3 82.1S230.4-21.2 344 4c-2.1 30.4.7 105.2-103.7 78.1z"
      className="st0"
    />
  </svg>
);

export default Patientory;
